import styled from "styled-components";

//Interfaces
import { ConversationsInterface, StatusInterface } from "./interfaces";

//Assets
import colors from "../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 130px;
    /* margin-left: -37px; */
    padding-top: 17px;
    padding-bottom: 17px;
    padding-right: 17px;

    border-top: 1px solid #E6E9F2;
    border-bottom: 1px solid #E6E9F2;

    cursor: pointer;

    @media (max-width: 500px){
        margin-left: 0px;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-left: ${(p: ConversationsInterface) => p.isNew ? "19px" : "51px"};
`;

export const CircleRed = styled.div`
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background-color: #F46B45;
    /* margin-left: 30px; */
    margin-right: 20px;
`;

export const ConversationTopic = styled.h2`
    font: normal normal normal 12px Circular Std Book;
    color: #454546;
    margin-bottom: 0px;
    line-height: 1;
`;

export const Payload = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 50px;
    
    
    margin-left: 51px;
`;

export const UserAndDateRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -25px;
`;

export const UserInfo = styled.span`
    font: normal normal normal 10px Circular Std Book;
    color: #B8B4CC;
`;

export const DateInfo = styled.span`
    font: normal normal normal 11px Circular Std Book;
    color: #B8B4CC;
`;

export const StatusContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 68px;
    height: 19px;

    border-radius: 9px;

    background-color: ${(p: StatusInterface) => p.color};
`;

export const StatusText = styled.span`
    font: normal normal normal 9px Circular Std Book;
    color: ${(p: StatusInterface) => p.color};
    font-weight: bold;
`;